// „Топ 5 по оборот" — подредени артикули с ранг, количество и сума.
// Лентата под името е делът спрямо първия, не спрямо общото.

import { useTranslation } from "react-i18next";

import { useReportLink } from "../useReportLink";
import { RightOutlined } from "@ant-design/icons";

import { fmtEuro } from "../../../../utils/currency";
import { parseDecimal } from "../../../../components/dataTable";
import type { DashboardTopItem } from "../../../../api/reportsDashboard";

type Props = { items: DashboardTopItem[] };

export const TopItemsCard = ({ items }: Props) => {
  const { t } = useTranslation();
  const openReport = useReportLink("assortment");

  const rows = items.map((item) => ({
    ...item,
    value: parseDecimal(item.total_sum),
    quantity: parseDecimal(item.count),
  }));
  const top = rows.length ? rows[0].value : 0;

  return (
    <section className="flex min-w-0 flex-col rounded-xl border border-shade-2 bg-surface px-4 py-3.5">
      <header className="mb-3 flex items-baseline justify-between gap-2">
        <h2 className="font-pos-mono text-[10.5px] font-bold uppercase leading-none tracking-[0.1em] text-muted">
          {t("reportsPage.dashTopTitle")}
        </h2>
        {openReport ? (
          <button
            type="button"
            onClick={openReport}
            className="flex items-center gap-1 text-[12px] font-bold text-brand-deep-ink hover:underline"
          >
            {t("reportsPage.dashAllItems")}
            <RightOutlined className="text-[9px]" />
          </button>
        ) : null}
      </header>

      {rows.length ? (
        <ul className="flex flex-col gap-2.5">
          {rows.map((item, index) => (
            <li key={item.item_id} className="flex flex-col gap-1">
              <div className="flex items-baseline gap-2">
                <span className="w-3 shrink-0 font-pos-mono text-[11px] font-bold tabular-nums text-faint">
                  {index + 1}
                </span>
                <span className="min-w-0 flex-1 truncate text-[13px] font-medium text-ink">
                  {item.name}
                </span>
                <span className="font-pos-mono text-[11.5px] font-semibold tabular-nums text-muted">
                  {t("reportsPage.dashPieces", {
                    count: Math.round(item.quantity),
                  })}
                </span>
                <span className="w-[86px] shrink-0 text-right font-pos-mono text-[13px] font-bold tabular-nums text-ink">
                  {fmtEuro(item.value)}
                </span>
              </div>
              <span className="ml-5 h-1 overflow-hidden rounded-full bg-fill-2">
                {/* Делът спрямо първия е известен чак по време на изпълнение. */}
                <span
                  className={`block h-full rounded-full ${
                    index === 0 ? "bg-brand" : "bg-brand-tint2"
                  }`}
                  style={{ width: `${top > 0 ? (item.value / top) * 100 : 0}%` }}
                />
              </span>
            </li>
          ))}
        </ul>
      ) : (
        <p className="py-6 text-center text-[12.5px] font-medium text-muted">
          {t("reportsPage.dashNoData")}
        </p>
      )}
    </section>
  );
};
